import { render, staticRenderFns } from "./Pro.vue?vue&type=template&id=c83a0e8e&"
import script from "./Pro.vue?vue&type=script&lang=ts&"
export * from "./Pro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports